import { ModelEnhancer } from 'state/ModelEnhancer';
/**
 * School data and related utilities.
 */
export class School extends ModelEnhancer {
    createStruct(_data) {
        return null;
    }
}
